import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle
} from "reactstrap";
import axios from "axios";
import _ from "lodash";

import FoodUserThumbnail from "../medium/FoodUserThumbnail";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3030";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      username: "",
      email: "",
      photo: "",
      userFoods: []
    };
    this.deleteFood = this.deleteFood.bind(this);
  }

  async getDataFood() {
    await axios
      .get(`${API_URL}/foods`)
      .then(res => {
        res.data.data.forEach(dataId => {
          if (dataId._account === window.localStorage.userId) {
            this.setState({
              userFoods: this.state.userFoods.concat([dataId])
            });
          }
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getDataAccount() {
    if (window.localStorage.id) {
      await axios
        .get(`${API_URL}/accounts/${window.localStorage.id}`)
        .then(res => {
          this.setState({
            firstName: _.capitalize(res.data.data.firstName),
            lastName: _.capitalize(res.data.data.lastName),
            username: res.data.data.username,
            email: res.data.data.email,
            profile_picture: res.data.data.profile_picture
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  async deleteFood(target_index) {
    const id = this.state.userFoods[target_index].id;
    await axios({
      url: `${API_URL}/foods/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + window.localStorage.token
      }
    })
      .then(res => {
        let userFoods = this.state.userFoods;
        for (var i = 0; i < userFoods.length; i++) {
          if (userFoods[i].id === id) {
            userFoods.splice(i, 1);
          }
        }
        this.setState({ userFoods: userFoods });
      })
      .catch(err => {
        console.log(err);
      });
  }

  componentWillMount() {
    this.getDataAccount();
    this.getDataFood();
  }

  render() {
    return (
      <div>
        <div>
          <h1 className="center">
            Hi {`${this.state.firstName} ${this.state.lastName}`} Welcome to
            Profile Page
          </h1>
        </div>
        <Row>
          <Col>
            <div className="center">
              <Card>
                {this.state.profile_picture ? (
                  <CardImg
                    top
                    width="50%"
                    src={this.state.profile_picture}
                    alt="Card image cap"
                  />
                ) : (
                  <CardImg top width="50%" />
                )}

                <CardBody>
                  <CardTitle>
                    {`${this.state.firstName} ${this.state.lastName}`}
                  </CardTitle>
                  <CardText>{this.state.email}</CardText>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
        <Row className="homeProduct center">
          <FoodUserThumbnail
            deleteFood={this.deleteFood}
            userFoods={this.state.userFoods}
          />
        </Row>
      </div>
    );
  }
}
export default Profile;



// WEBPACK FOOTER //
// ./src/page/Profile.jsx